export default __webpack_public_path__ + "static/media/glasses8.f3ce43c2.jpeg";